//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfLoader from "~/themes/fiskarsMoominDefault/components/components/atoms/SfLoader/SfLoader.vue";
import { useRoute, computed, useContext, ref, onMounted, watch } from "@nuxtjs/composition-api";
import { getCMSLabels } from "~/helpers/globalLabels";
import {
  useBloomreach,
  useSapcc,
  useSalesCrm,
  useUiNotification,
} from "~/composables";
import CategoryBreadcrumbs from "~/components/Category/CategoryBreadcrumbs.vue";
import { onSSR } from "@vue-storefront/core";
import { CMSNotificationType } from "~/helpers/extractCMSNotificationMessage";
import { COOKIES } from "~/helpers/constants";
import useProductMixin from '@/mixins/product';
import { adaptProduct } from "~/helpers/analytics/helper";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { AnalyticsCartActions } from "~/helpers/analytics/types";
import { useUserStore } from "~/stores/user-store";

export default {
  name: "Product",
  transition: "fade",
  components: {
    SfLoader,
    MoominProductDetails: () => import("~/components/cms/page/MoominProductDetails.vue"),
    ProductSlider: () => import("~/components/cms/page/ProductSlider.vue"),
    CardHorizontal: () => import("~/components/cms/page/CardHorizontal.vue"),
    CategoryBreadcrumbs,
  },
  head() {
    if (!this.brxProductData) return {}; // Prevent unnecessary data fetching

    const title = this.getData("shortname");
    const metaTitle = this.getData("metaTitle");
    const metaDescription = this.getData("metaDescription");
    const indexingStatus = this.checkIndexing();
    const primaryImageUrl = this.getPrimaryImageUrl();

    const locales = this.$i18n.locales;
    const availableTranslations = this.productInfo?.shortNameValueList?.entry;

    // updated hreflangs
    const hrefLangs = availableTranslations
    ? availableTranslations
    .filter((translation) => translation.value) // Ensure translation.value exists
    .map((translation) => ({
      rel: "alternate",
      hid: `i18n-alt-${this.convertLocaleToUnderscoreFormat(translation.key)}`,
      href: this.generateProductURL(translation.key, translation.value),
      hreflang: translation.key,
    }))
    : // TODO: Remove this else part once DART-9404 is released for SAPCC
    locales.map((locale) => ({
      rel: "alternate",
      href: this.generateProductURL(locale.code, title),
      hreflang: locale.iso,
      hid: `i18n-alt-${locale.iso}`
    }));

    const canonicalLink = {
      hid: 'i18n-can',
      rel: 'canonical',
      href: this.resolvedProductUrl
    };

    return {
      title,
      meta: [
        { hid: "description", name: "description", content: metaDescription },
        { hid: "title", name: "title", content: metaTitle },
        { hid: "keywords", name: "keywords", content: metaTitle },
        { hid: "og:title", name: "og:title", content: metaTitle },
        { hid: "og:keywords", name: "og:keywords", content: metaTitle },
        { hid: "og:description", name: "og:description", content: metaDescription },
        { hid: "robots", name: "robots", content: indexingStatus },
      ],
      link: [canonicalLink, ...hrefLangs],
      script: [
        {
          type: 'application/ld+json',
          defer: true,
          json: {
            "@context": "http://schema.org",
            "@type": "Product",
            "@id" : `${this.prodId}`,
            "description": metaDescription,
            "name": metaTitle,
            "image": primaryImageUrl,
            "brand": "MOOMIN",
            "sku": this.prodId,
            "gtin": this?.productInfo?.eanOrUpc,
            "offers": {
              "@type": "Offer",
              "url": this.resolvedProductUrl,
              "availability": `http://schema.org/${this?.productInfo?.stock?.stockLevelStatus}`,
              "price": this?.priceInfo?.regular_price,
              "priceCurrency": this?.priceInfo?.currency,
              "priceSpecification": [
                {
                  "@type": "UnitPriceSpecification",
                  "priceType": "https://schema.org/SalePrice",
                  "price": this?.priceInfo?.discounted_price > 0 ? this?.priceInfo?.discounted_price : undefined,
                  "priceCurrency": this?.priceInfo?.currency
                },
                {
                  "@type": "UnitPriceSpecification",
                  "priceType": "https://schema.org/ListPrice",
                  "price": this?.priceInfo?.regular_price,
                  "priceCurrency": this?.priceInfo?.currency
                }
              ]
            }
          }
        }
      ],
    };
  },

  methods: {
    generateProductURL(localeCode, title) {
      if (!localeCode || !title ) {
        throw new Error("Missing param: localeCode or title");
      }

      const sanitizedTitle = title.replace(/\W+/g, "-").toLowerCase();
      return `${this.$config.productionURL}/${localeCode}/p/${sanitizedTitle}-${this.prodId}`;
    },
    convertLocaleToUnderscoreFormat(key) {
      if (!key || typeof key !== 'string') {
        throw new Error('Invalid key input');
      }
      if(key == "int"){
        key = "en-us";
      }
      // Check if the key contains a hyphen
      if (!key.includes('-')) {
        return key.toLowerCase();
      }

      const [language, region] = key.split('-');

      // Format for hreflang HID
      return `${language.toLowerCase()}_${region?.toUpperCase()}`;
    },
    fetchData(itemToExtract, callbackfn = null, heading = "") {
      const { getData } = this.$options.setup();
      return getData(itemToExtract, callbackfn, heading)
    },
    generateBreadcrumbs() {
      const linkSecondaryData = this.getData("linkSecondary");

      if (linkSecondaryData) {
        const breadCrumbArr = Object.values(linkSecondaryData).map(
          (bcItem, index) => ({
            text: bcItem?.data?.description
              ?.split("-")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            link: this.getLink(
              this.resolveRef(this.replaceContent(bcItem.data.link))
            ),
          })
        );
        breadCrumbArr.push({
          text: this.capitalizeFirstLetter(this.getData("dname")),
          link: "",
        });
        return breadCrumbArr;
      }

      return [];
    },
    checkIndexing() {
      const noIndex = this.getData("noIndex");
      const noFollow = this.getData("noFollow");

      if (noIndex && noFollow) {
        return "noindex,nofollow";
      } else if (noIndex) {
        return "follow,noindex";
      } else if (noFollow) {
        return "nofollow,index";
      } else {
        return "follow,index";
      }
    },
    hasProductMeta() {
      const productData = this.getData("product")?.data;
      this.productSlider = !!productData?.productSlider;
      this.similarProducts = !!productData?.similarProducts;
      this.fiftyFiftyBanner = !!productData?.fiftyFiftyBanner;
      return this.getData("product");
    },
    extractProductMeta(attrName, componentName) {
      const isRef = this.checkForRefs(
        this.resolveProductMeta(componentName)?.data?.[attrName]
      );
      if (isRef) {
        return this.resolveRef(
          this.replaceContent(
            this.resolveProductMeta(componentName)?.data?.[attrName]
          )
        );
      }
      return this.resolveProductMeta(componentName)?.data?.[attrName];
    },
    getText(resovedObj) {
      return resovedObj?.data?.dname;
    },
    getLink(linkObj) {
      return this.localePath(linkObj?.links?.site?.href);
    },
    sortItemsByFileName(items) {
      return items.sort((a, b) => {
        const fileNameA = a.name.split("_").pop().split(".")[0];
        const fileNameB = b.name.split("_").pop().split(".")[0];

        return fileNameA.localeCompare(fileNameB);
      });
    },
    getImage(imgObj) {
      return {
        desktop: imgObj?.data?.original?.links?.site?.href,
        mobile: imgObj?.data?.small?.links?.site?.href,
        thumbnail: imgObj?.data?.thumbnail?.links?.site?.href,
        alt: imgObj?.data?.displayName,
      };
    },
    getUserEmail() {
      const userCookieData = this.$cookies.get(COOKIES.USER_DATA);
      return userCookieData &&
        userCookieData !== "null" &&
        userCookieData !== "undefined"
        ? userCookieData.e
        : "";
    },
    getEmailInfo() {
      return {
        value: this.getUserEmail(),
        placeholder: getCMSLabels("product-details-email-address-placeholder"),
        error: false,
        errorMessage: getCMSLabels("updateemail"),
      };
    },
    getPrimaryImageUrl(){
      return this.$getSapImageUrl(this.brxProductImages?.[0]?.mobile?.url)
    },
    async addItemToCart(addToCartObj) {
      const addToCartResponse = this.handleProductAddToCart(this.getData('pdpavailable'));
      if (!addToCartResponse) {
        return;
      }

      const productForEvent = adaptProduct(this.analyticsProductInfo(), 'Product')
      analyticsEvents.updateCartItem(AnalyticsCartActions.ADD, productForEvent)

      try {
        await this.addCartItem({
          code: this.prodId,
          qty: addToCartObj.qty,
          primaryImageUrl: this.getPrimaryImageUrl(),
        });

        if (this?.cartError?.status) {
          const errorMessage = this.exceededError;
          if (
            this.cartError.reason === "maxProductQuantityExceeded" &&
            errorMessage
          ) {
            this.cartError.message = errorMessage;
          }
          this.sendNotification({
            type: CMSNotificationType.ERROR,
            message: `${this.productQuantityExceededMessage}`,
          });
        } else {
          this.sendNotification({
            type: CMSNotificationType.SUCCESS,
            message: `${this.getData("dname")} ${this.addedToCartMessage}.`,
          });
          this.loadExistingCart();
        }
      } catch (error) {
        this.sendNotification({
          type: CMSNotificationType.ERROR,
          message: error,
        });
      }
    },
    async processNotifyme(email) {
      if (email.error) {
        this.emailCMS = {
          value: email?.value,
          placeholder: "Email address",
          error: true,
          errorMessage: "Please update your email",
        };
        return;
      }
      await this.notifyProductBackInStock({
        email: email?.value,
        productId: this.prodId,
        productName: this.getData("shortname"),
      });

      this.emailCMS = {
        value: email?.value,
        placeholder: "Email address",
        error: this.notifiedStatus.success,
        errorMessage: "You'll be get notified, once product will be inStock",
      };
      if (this.notifiedStatus.success) {
        this.sendNotification({
          type: CMSNotificationType.SUCCESS,
          message: this.notifyStockMessage,
        });
      }
    },
    getProductSliderData(resovedObj) {
      return {
        addToCart: resovedObj?.data?.addToCart || "Add to Cart",
        badgeColor: resovedObj?.data?.badgeColor,
        buttonText: resovedObj?.data?.buttonText,
        description: resovedObj?.data?.description,
        link: resovedObj?.data?.link,
        numberOfResults: resovedObj?.data?.numberOfResults,
        productType: resovedObj?.data?.productType,
        titleCarousel: resovedObj?.data?.titleCarousel,
      };
    },
    extractBannerData(resovedObj) {
      return {
        Subtitle: resovedObj?.data?.subtitle,
        background: resovedObj?.data?.background,
        buttonText: resovedObj?.data?.buttonText,
        description: resovedObj?.data?.description,
        image: resovedObj?.data?.image,
        layout: resovedObj?.data?.layout,
        link: resovedObj?.data?.link,
        linkSecondary: resovedObj?.data?.linkSecondary,
        secondaryButtonText: resovedObj?.data?.secondaryButtonText,
        title: resovedObj?.data?.title,
        titleLevel: resovedObj?.data?.titleLevel,
      };
    },
    getOutOfStockText() {
      return {
        status: this.displayNotificationBox,
        title: this.productStatusLabel, // product-details-comingsoon-text, product-details-outofstock-text, product-details-new-stock-arriving-text
        label: getCMSLabels("get-notified"),
        info: getCMSLabels("product-details-emailaddresstooltip"),
        button: getCMSLabels("pdp-get-notify-button-text"),
        disclaimer: this.$t("notify-me-disclaimer"),
        disclaimerUrl: this.$t("privacy-policy-url"),
        privacyPolicy: this.$t("privacy-policy")
      };
    },
    analyticsProductInfo() {
      return {
        name: this.getData("dname"),
        id: this.productInfo?.code,
        link: this.productInfo?.url,
        specialPrice: this.priceInfo?.discounted_price || this.priceInfo?.regular_price,
        regularPrice: this.priceInfo?.regular_price,
        item_name: this.getData("dname"),
        item_id: this.productInfo?.code,
        collection: this.productInfo?.collectionName,
        item_brand: this.productInfo?.brandName,
        price: this.priceInfo?.regular_price,
        product_url: this.productInfo?.url,
        discount: this.priceInfo?.discounted_price
      }
    },
    getProductInfo() {
      return {
        title: this.getData("dname"),
        subtitle: this.getData("link", this.getCollectionInfo)?.title,
        Title: this.getData("dname"),
        maxQty: this.maxAllowedQty,
        minQty: this.minAllowedQty,
        minAllowedQtyToShow: this.minAllowedQtyToShow,
        maxAllowedQtyToShow: this.maxAllowedQtyToShow,
        analytics: this.analyticsProductInfo(),
        exclusivePrice: this.productInfo?.exclusivePrice,
        raw: {
          currency: this.priceInfo?.currency,
          shortname: this.getData("shortname"),
          permanentid: this.productInfo?.code,
          classification_productspecifictype: ["Mugs"],
          price_discounted: this.priceInfo?.discounted_price,
          price_regular: this.priceInfo?.regular_price,
          stock: this.isPurchasable ? "inStock" : "outofstock",
          classification_productgenerictype: ["Mugs and cups"],
          lowest_price: this.priceInfo?.lowest_price,
          imageurl:this.getPrimaryImageUrl()
        },
      };
    },
    getDataValue(itemToExtract) {
      return this.getData(itemToExtract);
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getSpecifications(heading = "") {
      const specifications = {
        productArticleNumber: this.$t('PRODUCT_ARTICLE_NUMBER'),
        ean: "EAN",
        width: this.$t('PRODUCT_WIDTH'),
        height: this.$t('PRODUCT_HEIGHT'),
        length: this.$t('PRODUCT_LENGTH'),
        weight: this.$t('PRODUCT_WEIGHT')
      };

      const details = {};
      Object.entries(specifications).forEach(([key, spec]) => {
        details[this.capitalizeFirstLetter(spec)] = this.getDataValue(key);
      });

      return {
        summary: heading,
        details,
      };
    }
,
    resolveProductMeta(metaKey) {
      const productMeta = this.getData("product")?.data?.[metaKey];
      const extractedRef = this.replaceContent(productMeta);

      return this.resolveRef(extractedRef);
    },
    resolveIconHref(imageData) {
      const replacedContent = this.replaceContent(imageData);
      const resolvedContent = this.resolveRef(replacedContent);

      return resolvedContent?.data?.banner?.links?.site?.href;
    },
    getServiceProducts(resolvedObj) {
      return Object.keys(resolvedObj).map((callout) => {
        const imageData = resolvedObj[callout]?.data?.image;
        const description = resolvedObj[callout]?.data?.description;

        const iconHref = this.resolveIconHref(imageData);

        return {
          icon: iconHref,
          text: description,
        };
      });
    },
    getCollectionInfo(resolvedObj) {
      const displayName = resolvedObj?.data?.description;
      const collectionContents = resolvedObj?.data?.content?.value;

      return {
        hasDetails: !!collectionContents || !!displayName,
        title: displayName,
        summary: getCMSLabels("product-detail-collection"),
        link: this.getLink(
          this.resolveRef(this.replaceContent(resolvedObj?.data?.link))
        ),
        details: {
          value: `${displayName}${collectionContents}` || "",
        },
      };
    },
    getDifferenceInDays(targetDate) {
      const millisecondsPerDay = 24 * 60 * 60 * 1000;
      const timeDifference = Date.now() - targetDate.getTime();
      return Math.floor(timeDifference / millisecondsPerDay);
    },
    getProductDiscountPercentage() {
      const regular_price = this.priceInfo.regular_price
      const discount_price = this.priceInfo.discounted_price
      const discount = regular_price - discount_price

      const discount_percentage =(discount/regular_price) * 100
      return Math.trunc(discount_percentage.toFixed(0))
    },
    getSystemDefinedBadges() {
      const discounted = this.priceInfo.discounted_price || 0;
      const productOnlineFrom = this.getData("productOnlineFrom");
      const isExclusive = this.checkOnlyAvailableTo;

      if (isExclusive) {
        return getCMSLabels("my-moomin-exclusive") || "MyMoomin Exclusive";
      }

      if (this.productInfo?.exclusivePrice?.value > 0 && !this.priceInfo.isOnDiscount && this.isUserLoggedIn) {
          // If the user is logged in and exclusive price is available, show the exclusive price.
          return "";
      } else if (discounted > 0) {
          // If the user is not logged in or exclusive price is not available but discounted price is greater than 0, show the sale label.
          return getCMSLabels("sale") || "Sale";
      }


      if (productOnlineFrom) {
        const targetDate = new Date(productOnlineFrom);
        const productFreshness = this.getDifferenceInDays(targetDate);

        if (productFreshness < 60) {
          return getCMSLabels("new") || "New";
        }
      }

      return "";
    },

    getUserDefinedBadges(resolvedObj) {
      const sysBadges = this.getSystemDefinedBadges();
      let badgeColor = this.checkOnlyAvailableTo ? "var(--c-secondary-purple)" : "var(--c-secondary)";
      return Object.entries(resolvedObj)
        .map(
          ([
            badge,
            {
              data: { color, displayName },
            },
          ]) => {
            badgeColor = color.background.selectionValues?.[0].key;
            return {
              value: displayName,
              color: badgeColor,
            };
          }
        )
        .concat(sysBadges ? [{ value: sysBadges, color: badgeColor }] : []);
    },
  },
  setup() {
    const route = useRoute();
    const { error: nuxtError, i18n, $config, redirect } = useContext();
    const userStore = useUserStore();
    const id = route?.value?.params?.id ? route.value.params.id.split('/').filter(Boolean).pop() : null;
    const slugParts = id?.split("-") || [];
    const skuId = parseInt(slugParts[slugParts.length - 1]);
    const requestedShortNameSlug = slugParts.slice(0, slugParts.length - 1).join("-")?.replace(/\W+/g, "-")?.toLowerCase(); // Join the rest back as shortname
    const { send: sendNotification } = useUiNotification();
    const prodId = isNaN(Number(skuId)) ? null : skuId;
    const exceededError = getCMSLabels("product-available");
    const notifyStockMessage = getCMSLabels("notify-product");
    const addedToCartMessage = getCMSLabels("added-cart");
    const productQuantityExceededMessage = getCMSLabels("productquantity");

    // Check for the products meta
    const productSlider = ref(false);
    const fiftyFiftyBanner = ref(false);
    const badges = ref(false);
    const similarProducts = ref(false);
    const isVideoAvailable = ref(false);

    const { fetchProductData, productData: brxProduct } = useBloomreach(
      `pdp-productData-${prodId}`
    );
    const { fetchProductImages, productData: brxProductImages } = useBloomreach(
      `pdp-productImages-${prodId}`
    );

    const { fetchProductPriceInventory, result: productInfo, error: sapccProductError  } = useSapcc(
      `pdp-productInfo-${prodId}`
    );

    const {
      result: cartStatus,
      addToShoppingCart: addCartItem,
      loading: cartLoader,
      error: cartError,
    } = useSapcc("cartPDP");
    const { result: updatedCart, getShoppingCart: loadExistingCart } =
      useSapcc("existingCart");
    const {
      notifyProductBackInStock,
      result: notifiedStatus,
      loading: notifyMeLoader,
    } = useSalesCrm("notify-backin-stock");

    const isProductAccessible = computed(()=> productInfo?.value?.isVisible && productInfo?.value?.status == "APPROVED");
    const accessibleProductSlug = computed(()=> productInfo?.value?.shortName?.replace(/\W+/g, "-")?.toLowerCase());
    const resolvedProductUrl = computed(()=> `${$config.productionURL}/${i18n.locale}/p/${accessibleProductSlug.value}-${prodId}`)
    const brxProductData = computed(() => brxProduct?.value);
    const loadingPage = computed(() => !brxProductData?.value);
    const existingQtyInCart = computed(() => {
      return (
        updatedCart?.value?.entries?.find(
          (entry) => entry?.product?.code == prodId
        )?.quantity || 0
      );
    });

    //get max quantity
    const maxQtyConfigured = computed(
      () => productInfo?.value?.maxOrderQuantity ?? 0
    );
    const currentStockLevel = computed(
      () => productInfo?.value?.stock?.stockLevel ?? 0
    );
    const minQtyConfigured = computed(
      () => productInfo?.value?.minOrderQuantity ?? 1
    );

    const maxAllowedQty = computed(() =>
      Math.max(
        0,
        Math.min(maxQtyConfigured?.value, currentStockLevel?.value) -
          existingQtyInCart?.value
      )
    );

    const maxAllowedQtyToShow = computed(() =>
      Math.max(
        0,
        Math.min(maxQtyConfigured?.value, currentStockLevel?.value)
      )
    );

    const minAllowedQty = computed(() =>
      minQtyConfigured?.value > 0
        ? Math.min(
            maxAllowedQty?.value > maxQtyConfigured?.value
              ? maxQtyConfigured?.value
              : maxAllowedQty?.value,
            currentStockLevel?.value === existingQtyInCart?.value ? 0 : 1
          )
        : 1
    );

    const minAllowedQtyToShow = computed(() =>
      minQtyConfigured?.value > 0
        ? Math.min(
            maxAllowedQty?.value > maxQtyConfigured?.value
              ? maxQtyConfigured?.value
              : maxAllowedQty?.value,
            currentStockLevel?.value === existingQtyInCart?.value ? 0 : 1
          )
        : 1
    );
    const isUserLoggedIn = userStore.getUserIsLoggedIn;
    const isMaxLimitReached = computed(() => minAllowedQty?.value == 0 || maxAllowedQty?.value == 0);

    // check if product is purchasable
    const isPurchasable = computed(() => productInfo?.value?.purchasable);

    const getMinPrice = computed(() => productInfo?.value?.lowestPrice?.value);
    const getRegularPrice = computed(() => productInfo?.value?.price?.value);
    const getCurrency = computed(() => productInfo?.value?.price?.currencyIso);
    const promotionPrices = computed(
      () => productInfo?.value?.price?.promotionPrices
    );
    const crossOutPrice = computed(
      () => productInfo?.value?.crossOutPrice?.value
    );

    // Check only availabe to
    const checkOnlyAvailableTo = computed(
      () => productInfo?.value?.onlyAvailableTo
    );

    // Determine if the promotion is specific to a baseStore or global. If it's baseStore-specific, apply it only if it matches the current baseStore
    const findPromotion = (promotions, baseStore, targetCode) => promotions.find(promotion => !promotion.baseStore || (promotion.code === targetCode && promotion.baseStore === baseStore));

    // check if product is purchasable
    const priceInfo = computed(() => {
      let availablePromoions;
      if (promotionPrices?.value?.length > 0) {
        // Finding the promotion
        availablePromoions = findPromotion(productInfo?.value.applicablePromotions, i18n.localeProperties.baseStoreId, promotionPrices?.value?.[0]?.promotionCode);
      }

      const discountedPrice =
        availablePromoions
          ? promotionPrices?.value?.[0].price
          : 0.0;

      return {
        lowest_price: getMinPrice?.value,
        regular_price: crossOutPrice?.value ? crossOutPrice?.value : getRegularPrice?.value,
        discounted_price: crossOutPrice?.value ? getRegularPrice?.value : discountedPrice,
        currency: getCurrency?.value,
        isOnDiscount: availablePromoions?.length > 0
      }
    });

    const displayNotificationBox = computed(
      () =>
        !productInfo?.value?.purchasable ||
        (productInfo?.value?.stock?.stockLevelStatus?.toLowerCase() ===
          "outofstock" &&
          productInfo?.value?.showBackInStockNotification)
    );

    const productStatusLabel = computed(() => {
      const stockStatus =
        productInfo?.value?.stock?.stockLevelStatus?.toLowerCase();
      const showBackInStockNotification =
        productInfo?.value?.showBackInStockNotification;
      const productLifecycleStatus = productInfo?.value?.productLifecycleStatus;

      if (stockStatus === "outofstock" && showBackInStockNotification) {
        switch (productLifecycleStatus) {
          case "COMING_SOON":
            return getCMSLabels("product-details-comingsoon-text");
          case "NEW_STOCK_ARRIVING_SOON":
            return getCMSLabels("product-details-new-stock-arriving-text");
          default:
            return getCMSLabels("product-details-outofstock-text");
        }
      }
      return "";
    });

    const getAccordionItem = (resolvedObj, heading = "") => {
      const hasDescription =  heading === getCMSLabels('pdp-delivery-accordion-title') ? true : !!resolvedObj?.data?.description?.value;
      const details =
        heading === getCMSLabels('pdp-delivery-accordion-title')
          ? {
              value: getCMSLabels('delivery-and-returns'),
            }
          : resolvedObj;

      return {
        hasDetails: hasDescription,
        summary: heading,
        details,
      };
    };

    onSSR(async () => {
      try {
        if (!prodId) {
          nuxtError({ statusCode: 404 });
          return;
        }

        // validate SAPCC product by ID
        await fetchProductPriceInventory({ productCode: prodId });

        // Check SAPCC 404 first
        if (sapccProductError?.value?.status === 404 || !isProductAccessible?.value) {
          nuxtError({ statusCode: 404 });
          return;
        }

        // Validate slug
        if (accessibleProductSlug.value !== requestedShortNameSlug) {
          redirect(301, resolvedProductUrl.value);
          return; // Exit before Bloomreach calls
        }

        // Only make Bloomreach calls if we passed all checks
        await Promise.all([
          fetchProductImages({ id: prodId }),
          fetchProductData({ id: prodId })
        ]);

      } catch (error) {
        if (error?.response?.status === 404) {
          nuxtError({ statusCode: 404 });
        } else {
          console.error("SSR Error:", error);
          nuxtError({ statusCode: 500 });
        }
      }
    });

    const checkForRefs = (jsonObj) => {
      const refs = [];

      const traverse = (obj) => {
        if (obj && typeof obj === "object") {
          if ("$ref" in obj) {
            refs.push(obj.$ref);
          }
          for (const key in obj) {
            traverse(obj[key]);
          }
        }
      };

      traverse(jsonObj);
      return refs.length > 0;
    };

    const replaceContent = (json) => {
      return Array.isArray(json)
        ? json.map(({ $ref, ...obj }) => ({
            $ref: $ref?.replace("/content/", ""),
            ...obj,
          }))
        : {
            ...json,
            $ref: json?.$ref?.replace("/content/", ""),
          };
    };

    const getJsonFromPath = (path) => {
      return brxProductData?.value?.content?.[path];
    };

    const resolveRef = (obj, depth = 1) => {
      if (typeof obj !== "object" || obj === null) {
        return obj;
      }
      const { $ref, ...rest } = obj;
      if ($ref) {
        return resolveRef(getJsonFromPath($ref), depth + 1);
      }

      // stop recursion if depth is greater than or equal to 3
      if (depth >= 3) {
        return rest;
      }

      // recursively resolve any child objects
      for (const [key, value] of Object.entries(rest)) {
        rest[key] = resolveRef(value, depth + 1);
      }

      return rest;
    };

    const getData = (itemToExtract, callbackfn = null, heading = "") => {
      const result =
        brxProductData?.value &&
        Object.values(brxProductData?.value?.content)?.find(
          (content) => content.data[itemToExtract]
        );

      if (result) {
        const extractedData = result.data[itemToExtract];
        const isRef = checkForRefs(extractedData);

        if (!isRef) {
          return callbackfn && typeof callbackfn === "function"
            ? callbackfn(extractedData, heading)
            : extractedData;
        }

        const replacedContent = replaceContent(extractedData);

        return callbackfn && typeof callbackfn === "function"
          ? callbackfn(resolveRef(replacedContent), heading)
          : resolveRef(replacedContent);
      }

      return callbackfn && typeof callbackfn === "function"
        ? callbackfn("", heading)
        : "";
    };

    const mixinData = {
      onlyAvailableTo: getData('pdpavailable'),
      isOutOfStock: !isPurchasable?.value,
      isListingPage: false,
    }

    const { getAddToCartButtonText, handleProductAddToCart, checkProductAvailability } = useProductMixin(mixinData);
    onMounted(async () => {
      await loadExistingCart();
    })

    watch([brxProduct, productInfo], () => {
      if (brxProduct?.value && productInfo?.value) {
        const onlyAvailable = getData('pdpavailable');
        checkProductAvailability(isPurchasable?.value, onlyAvailable);
      }
    })

    const socialMediaSiteNameId = getCMSLabels('bazaarvoiceproductslideid');

    return {
      socialMediaSiteNameId,
      exceededError,
      brxProductData,
      productInfo,
      brxProductImages,
      getAccordionItem,
      priceInfo,
      isPurchasable,
      maxAllowedQty,
      minAllowedQty,
      checkOnlyAvailableTo,
      displayNotificationBox,
      productStatusLabel,
      notifyProductBackInStock,
      notifyStockMessage,
      notifyMeLoader,
      prodId,
      notifiedStatus,
      addCartItem,
      cartStatus,
      cartError,
      sendNotification,
      cartLoader,
      getCMSLabels,
      productSlider,
      fiftyFiftyBanner,
      badges,
      similarProducts,
      isVideoAvailable,
      loadExistingCart,
      isMaxLimitReached,
      addedToCartMessage,
      productQuantityExceededMessage,
      minAllowedQtyToShow,
      maxAllowedQtyToShow,
      getAddToCartButtonText,
      getData,
      resolveRef,
      getJsonFromPath,
      replaceContent,
      checkForRefs,
      handleProductAddToCart,
      loadingPage,
      isUserLoggedIn,
      resolvedProductUrl,
      accessibleProductSlug
    };
  },
};
